import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'utils/cops-moment';
import { FormattedMessage } from 'react-intl';

export const SubTitle = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-weight: ${p => p.theme.fontWeight.bolder};
  border-bottom: 1px solid ${p => p.theme.colors.border};
  font-size: 20px;
  padding-bottom: 5px;
  margin-bottom: 10px;
`;

const Validated = styled.div`
  margin-left: 50px;
  font-size: 12px;
  color: grey;
  font-weight: 400;
  margin-left: 50px;
  text-transform: none;
`;

export const LastValidated = ({ date }) => {
  if (!date) {
    return null;
  }
  return (
    <Validated>
      <FormattedMessage id='common.LAST_VALIDATED' />
      {moment(date).fromNow()}
    </Validated>
  );
};

LastValidated.propTypes = {
  date: PropTypes.string,
};
